import { createSelector } from '@ngrx/store';

export const selectBillingState = (state: any) => state.billing;

export const selectBillingPortalUrl = createSelector(
  selectBillingState,
  state => state.data?.url
);

export const selectBillingPortalLoading = createSelector(
  selectBillingState,
  state => state.loading
);

export const selectBillingPortalError = createSelector(
  selectBillingState,
  state => state.error
);

export const selectBillingSuccess = createSelector(
  selectBillingState,
  state => state.billings
);

export const selectBillingError = createSelector(
  selectBillingState,
  state => state.error
);

export const selectInvoiceSuccess = createSelector(
  selectBillingState,
  state => state.invoiceData
);

export const selectInvoiceError = createSelector(
  selectBillingState,
  state =>  state.error
);
